import React from 'react';
import {connect} from 'react-redux';
import NavigationMenu from './NavigationMenu';
import buildNavItem from '../../../utils/NavItemBuilder';
import {logoutAction} from '../../../actions/Auth';
import {browserHistory} from 'react-router';

class ProfileMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: []
        };

        this.logout = this.logout.bind(this);
    }

    logout() {
        return new Promise((resolve) => {
            resolve(this.props.dispatch(logoutAction()).then(()=>{
                browserHistory.push('/');
            }));
        });
    }

    componentWillMount() {
        this.buildItems(this.props);
    }

    buildItems(props) {
        let items = [
            buildNavItem({href: '/profile', text: 'Профил'}),
            buildNavItem({href:'/statistics', text:'Статистики'}),
            buildNavItem({href: '/', text: 'Изход', clickHandler: this.logout})
        ];

        this.setState({items});
    }

    componentWillReceiveProps(newProps) {
        this.buildItems(newProps);
    }

    render() {
        return <NavigationMenu className={this.props.className} items={this.state.items} />
    }
}

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(null, mapDispatchToProps)(ProfileMenu);


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/ProfileMenu.js